import { AxiosInstance } from './axios.core';
import { API_URL } from './api.base';
import { CancelToken } from 'axios';
import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps } from './models'
export const uploadSignContent = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/sign/contents`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const getSignContentList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/sign/contents`, { params });
}

export const getSignContent = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/sign/contents/${id}`);
}

export const deleteSignContent = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/sign/contents/${id}`);
}

export const getAllSignContents = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/sign/contents/all`, { params });
}

export const addOrUpdateSignPlayPlan = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/sign/playplans`, {...params});
}

export const getSignPlayPlanList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/sign/playplans`, { params });
}

export const getSignPlayPlan= (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/sign/playplans/${id}`);
}

export const deleteSignPlayPlan = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/sign/playplans/${id}`);
}

export const moveSignPlayPlan = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/sign/playplans/move`, { ...params });
}